import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-226ceec6"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["width", "height"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  class: "icon-ndl-online-green",
  d: "M19.008 13.0292C19.5413 13.2426 20 13.0879 20 12.6826C20 12.2772 19.5707 11.7279 19.048 11.4639L15.2187 9.53324C14.6082 9.2644 13.9164 9.24716 13.2933 9.48524L4.97333 13.1866C4.43733 13.4239 4 13.8586 4 14.1466C4 14.4346 4.45333 14.5199 5.01067 14.3306L13.256 11.5146C13.9127 11.3266 14.6111 11.3424 15.2587 11.5599L19.008 13.0292Z"
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  class: "icon-ndl-online-yellow",
  d: "M18.9333 16.2186C19.5147 16.2986 20 16.0319 20 15.6266C20 15.2213 19.536 14.7733 18.9653 14.6293L15.3013 13.6986C14.6184 13.5531 13.9135 13.5431 13.2267 13.6693L5.04 15.4959C4.46933 15.6239 4 15.9653 4 16.2559C4 16.5466 4.47733 16.7333 5.06667 16.6586L13.216 15.6959C13.9196 15.627 14.6286 15.6342 15.3307 15.7173L18.9333 16.2186Z"
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  class: "icon-ndl-online-blue",
  d: "M13.3333 7.29328C13.6186 7.15218 13.9342 7.08349 14.2523 7.09325C14.5704 7.10302 14.8813 7.19095 15.1573 7.34928L19.0987 9.89595C19.592 10.2133 19.9947 10.1413 19.9947 9.73862C19.9947 9.33595 19.6133 8.70928 19.1467 8.35462L15.1147 5.28262C14.8614 5.10808 14.5633 5.01022 14.2559 5.00076C13.9484 4.9913 13.6448 5.07064 13.3813 5.22928L4.88533 10.92C4.4 11.2453 4 11.7493 4 12.04C4 12.3306 4.41867 12.3306 4.928 12.04L13.3333 7.29328Z"
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  class: "icon-ndl-online-orange",
  d: "M15.4667 17.8613C14.88 17.8613 13.92 17.8427 13.3333 17.8613L5.06667 17.968C4.48 17.968 4 18.1867 4 18.44C4 18.6933 4.47733 18.944 5.06667 19L13.2107 19.7493C13.9208 19.8032 14.6339 19.8032 15.344 19.7493L18.9333 19.4C19.5173 19.344 20 19 20 18.632C20 18.264 19.52 17.9493 18.9333 17.936L15.4667 17.8613Z"
}, null, -1))
const _hoisted_6 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", {
    class: "icon-ndl-online",
    width: _ctx.px,
    height: _ctx.px,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _hoisted_6, 8, _hoisted_1))
}